import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";
import { i18nRoot } from "../constants";
import { CustomThumbnailInput } from "./CustomThumbnailInput";

interface MediaSettingsProps {
  onCustomThumbnailUrlChange: (url: string | null) => void;
}

export const MediaSettings = ({
  onCustomThumbnailUrlChange,
}: MediaSettingsProps) => (
  <>
    <div className="px-6 py-5">
      <Form.Item
        name="custom_thumbnail"
        translationRoot={i18nRoot}
        hideBorder
        hideDescription
        fullWidth
        className="!p-0"
        labelClassName="!mb-3 !text-base"
      >
        <CustomThumbnailInput
          name="custom_thumbnail"
          title={t(`${i18nRoot}.thumbnail`)}
          description={t(`${i18nRoot}.thumbnail_description`)}
          onImageAttachSuccess={onCustomThumbnailUrlChange}
          onDelete={() => onCustomThumbnailUrlChange(null)}
        />
      </Form.Item>
    </div>
    <div className="border-primary border-t" />
    <div className="flex flex-col gap-4 px-6 py-5">
      <Typography.LabelMd weight="semibold">
        {t(`${i18nRoot}.settings_section`)}
      </Typography.LabelMd>
      <Form.Item
        name="make_downloadable"
        translationRoot={i18nRoot}
        hideBorder
        fullWidth
        inline
        className="!p-0"
      >
        <Form.ToggleSwitch variant="small" name="make_downloadable" />
      </Form.Item>
    </div>
  </>
);
